(function () {
  'use strict';
  if (window.KCWQuick) return;
  var doc = document;

  function $$(s, r) { return Array.prototype.slice.call((r || doc).querySelectorAll(s)); }
  function fill(text, map) {
    return String(text || '').replace(/\[(\w+)\]/g, function (all, k) { return k in map ? map[k] : all; });
  }
  function formatter(root) {
    if (!root.__fmt) {
      try { root.__fmt = new Intl.NumberFormat(root.getAttribute('data-locale') || 'en', { style: 'currency', currency: root.getAttribute('data-currency') || 'USD' }); }
      catch (e) { root.__fmt = { format: function (n) { return '$' + n.toFixed(2); } }; }
    }
    return root.__fmt;
  }
  function clamp(v) { return Math.max(0, Math.min(99, Math.round(parseFloat(v)) || 0)); }

  function render(root) {
    var fmt = formatter(root);
    var T = function (k) { return root.getAttribute('data-t-' + k) || ''; };
    var units = 0, total = 0, items = [];
    $$('[data-qk-line]', root).forEach(function (line) {
      var input = line.querySelector('[data-qk-qty]');
      var q = input ? clamp(input.value) : 0;
      var price = parseInt(line.getAttribute('data-price'), 10) || 0;
      var sum = line.querySelector('[data-qk-sum]');
      if (sum) sum.textContent = fmt.format(price * q / 100);
      line.classList.toggle('kcw-is-in', q > 0);
      if (q > 0) {
        units += q;
        total += price * q;
        items.push({ id: parseInt(line.getAttribute('data-vid'), 10), quantity: q });
      }
    });
    var count = units === 1 ? T('one') : fill(T('many'), { n: units });
    $$('[data-qk-units]', root).forEach(function (e) { e.textContent = count; });
    $$('[data-qk-total]', root).forEach(function (e) { e.textContent = fmt.format(total / 100); });
    var btn = root.querySelector('[data-qk-add]');
    if (!btn) return;
    btn.setAttribute('data-items', JSON.stringify(items));
    btn.setAttribute('data-toast', fill(T('toast'), { n: count }));
    if (btn.classList.contains('kcw-is-added')) return;
    if (units > 0) {
      btn.removeAttribute('aria-disabled');
      btn.textContent = fill(T('add'), { n: count, total: fmt.format(total / 100) });
    } else {
      btn.setAttribute('aria-disabled', 'true');
      btn.textContent = T('empty');
    }
  }

  function reset(root) {
    $$('[data-qk-qty]', root).forEach(function (i) { i.value = 0; });
    render(root);
  }

  doc.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('button');
    var root = t && t.closest('[data-kcw="quick"]');
    if (!root) return;
    if (t.hasAttribute('data-qk-q')) {
      var input = t.parentNode.querySelector('[data-qk-qty]');
      if (input) {
        input.value = clamp((parseInt(input.value, 10) || 0) + parseInt(t.getAttribute('data-qk-q'), 10));
        render(root);
      }
      return;
    }
    if (t.hasAttribute('data-qk-add')) {
      if (t.getAttribute('aria-disabled') === 'true') {
        var first = root.querySelector('[data-qk-qty]');
        if (first) first.focus();
        return;
      }
      root.__pending = Date.now();
    }
  }, true);

  doc.addEventListener('input', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-qk-qty]')) render(t.closest('[data-kcw="quick"]'));
  });
  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-qk-qty]')) {
      t.value = clamp(t.value);
      render(t.closest('[data-kcw="quick"]'));
    }
  });
  doc.addEventListener('keydown', function (e) {
    var t = e.target;
    if (e.key === 'Enter' && t.matches && t.matches('[data-qk-qty]')) {
      e.preventDefault();
      t.value = clamp(t.value);
      render(t.closest('[data-kcw="quick"]'));
    }
  });
  doc.addEventListener('cart:updated', function () {
    $$('[data-kcw="quick"]').forEach(function (root) {
      if (root.__pending && Date.now() - root.__pending < 15000) {
        root.__pending = 0;
        reset(root);
      }
    });
  });

  function init(scope) { $$('[data-kcw="quick"]', scope).forEach(render); }
  doc.addEventListener('shopify:section:load', function (e) { init(e.target); });
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { init(doc); });
  else init(doc);
  window.KCWQuick = { render: render };
})();
